import React, { useState } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  Typography,
  Tooltip,
  useTheme,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AccessControl, { FEATURE_IDS } from "../../../../../components/AccessControl";

const SendReminderButton = ({
  disabled,
  disabledReason = "",
  onReminderTypeSelect,
}) => {
  const theme = useTheme();
  const [menuAnchor, setMenuAnchor] = useState(null);

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const handleSelectType = (type) => {
    onReminderTypeSelect(type);
    handleMenuClose();
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <AccessControl featureId={FEATURE_IDS.PEOPLE_STAFF_SEND_REMINDER}>
        <Tooltip
          title={disabled && disabledReason ? disabledReason : "Send reminders to employees"}
          arrow
        >
          <span>
            <Button
              variant="contained"
              startIcon={<NotificationsIcon sx={{ fontSize: 16 }} />}
              endIcon={<ArrowDropDownIcon sx={{ fontSize: 16 }} />}
              onClick={handleMenuOpen}
              disabled={disabled}
              sx={{
                bgcolor: theme.customColors.button.primary,
                color: theme.customColors.button.text,
                fontWeight: 500,
                borderRadius: "8px",
                textTransform: "none",
                fontSize: "14px",
                px: 2,
                py: 1,
                "&:hover": { bgcolor: theme.palette._blue.dark },
                "&:disabled": {
                  bgcolor: theme.customColors.background.light,
                  color: theme.customColors.text.disabled,
                },
              }}
            >
              Send Reminder
            </Button>
          </span>
        </Tooltip>
      </AccessControl>
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 220,
            boxShadow:
              "0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
          },
        }}
      >
        <MenuItem
          onClick={() => handleSelectType("policy")}
          sx={{
            py: 1.5,
            px: 2,
            "&:hover": {
              backgroundColor: "#F3F4F6",
            },
          }}
        >
          <Box>
            <Typography
              variant="body2"
              fontWeight={600}
              color={theme.customColors.text.strong}
            >
              Policy Reminder
            </Typography>
            <Typography
              variant="caption"
              color={theme.customColors.text.secondary}
              sx={{ display: "block", mt: 0.25 }}
            >
              For pending policy acknowledgements
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem
          onClick={() => handleSelectType("training")}
          sx={{
            py: 1.5,
            px: 2,
            "&:hover": {
              backgroundColor: "#F3F4F6",
            },
          }}
        >
          <Box>
            <Typography
              variant="body2"
              fontWeight={600}
              color={theme.customColors.text.strong}
            >
              Training Reminder
            </Typography>
            <Typography
              variant="caption"
              color={theme.customColors.text.secondary}
              sx={{ display: "block", mt: 0.25 }}
            >
              For pending training completion
            </Typography>
          </Box>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default SendReminderButton;
